import { useTranslate } from 'react-admin'

import type { TimeSource } from '@/data/source'

export const useTimeLabels = () => {
  const translate = useTranslate()
  return {
    plannedFirst: translate('pages.scales.times.planned_first'),
    plannedLatest: translate('pages.scales.times.planned_latest'),
    actual: (source: TimeSource | null): string =>
      source === null
        ? translate('pages.scales.times.actual_unknown')
        : translate('pages.scales.times.actual', { source: translate(`pages.scales.times.sources.${source}`) }),
  }
}
